import React from "react";

export default function SQLServer_DATEADD() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_DATEADD</h1>
      <p>This is the SQLServer_DATEADD component generated from the SQL JSON.</p>
    </div>
  );
}
